import { IsDefined, IsInt } from 'class-validator';

export class PurchaseOrderInvoiceSaveMatchingDto {
  @IsDefined()
  @IsInt()
  invoiceId: number;

  @IsDefined()
  @IsInt()
  purchaseOrderId: number;
}